const Noop = () => null

export default Noop


// WEBPACK FOOTER //
// ./src/components/ofdCalc/Noop.js